// Generated by ReScript, PLEASE EDIT WITH CARE


function asEmoji(l) {
  switch (l) {
    case "Camel" :
        return "🐪";
    case "Crab" :
        return "🦀";
    case "Cowboy" :
        return "🤠";
    case "Cool" :
        return "😎";
    
  }
}

function fromString(s) {
  switch (s) {
    case "camel" :
        return "Camel";
    case "cool" :
        return "Cool";
    case "cowboy" :
        return "Cowboy";
    case "crab" :
        return "Crab";
    default:
      return "Crab";
  }
}

function toString(s) {
  switch (s) {
    case "Camel" :
        return "camel";
    case "Crab" :
        return "crab";
    case "Cowboy" :
        return "cowboy";
    case "Cool" :
        return "cool";
    
  }
}

var allLogos = [
  "Camel",
  "Crab",
  "Cowboy",
  "Cool"
];

export {
  asEmoji ,
  fromString ,
  toString ,
  allLogos ,
}
/* No side effect */
